<template>
  <div class="table-responsive mt-3" style="overflow: auto; padding-bottom: 30px; max-height: 70vh">
    <table class="table">
      <thead style="border: 1px solid lightgray">
      <tr style="background: #472F92 !important; color: white">
        <th style="width: 180px; ">Tên OKR</th>
        <th style="width: 120px">Loại OKR</th>
        <th style="width: 100px; word-break: break-word">Kpi mục tiêu</th>
        <th style="width: 100px; word-break: break-word">Kpi tối thiểu</th>
        <th style="width: 60px">Năm</th>
        <th style="width: 60px">Quý</th>
        <th style="width: 150px; word-break: break-word">Mã nhân sự tham gia</th>
        <th style="width: 100px">Exp</th>
        <th style="width: 150px; word-break: break-word">Mã nhân sự teamlead</th>
        <th style="width: 100px; word-break: break-word">Mã phòng ban</th>
        <th style="width: 150px; word-break: break-word">Trạng thái</th>
        <th style="width: 80px">Tiến độ</th>
        <th style="width: 180px">Lỗi</th>
      </tr>
      </thead>
      <tbody style="border: 1px solid lightgray">
      <tr v-for="item of responseError" :key="item?.index">
        <td style="text-align: start">
          <el-tooltip class="item" effect="dark" :content="item?.name" placement="top">
            <span class="line-clamp-1">{{ item?.name }}</span>
          </el-tooltip>
        </td>
        <td style="text-align: start; word-break: break-word">
          <el-tooltip class="item" effect="dark" :content="getType(item?.type)" placement="top">
            <span class="line-clamp-1">{{ getType(item?.type) }}</span>
          </el-tooltip>
        </td>
        <td style="text-align: start">{{ item.kpiTarget }}</td>
        <td style="text-align: start">{{ item.kpiMin }}</td>
        <td style="text-align: start">{{ item.year }}</td>
        <td style="text-align: start">{{ item.quarter }}</td>
        <td style="text-align: start">
          <el-tooltip class="item" effect="dark" :content="item.humanIds" placement="top">
            <span class="line-clamp-1">{{ item.humanIds }}</span>
          </el-tooltip>
        </td>
        <td style="text-align: start">
          <el-tooltip class="item" effect="dark" :content="item.exp" placement="top">
            <span class="line-clamp-1">{{ item.exp }}</span>
          </el-tooltip>
        </td>
        <td style="text-align: start">{{ item.leaderId }}</td>
        <td style="text-align: start">{{ item.departmentId }}</td>
        <td style="text-align: start">{{ getStatus(item.status) }}</td>
        <td style="text-align: start">{{ item.deadline ?? '' }}</td>
        <td><div v-if="item.error?.length > 0" style="text-align: start; display: flex; flex-direction: column">
          <span v-for="(err, index) in item.error" :key="index + err" style="word-break: break-word; color: red">
            {{err}}
          </span>
        </div></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'TableErrorImportOkr',
  data() {
    return {}
  },
  props: {
    responseError: {
      type: Array,
      default: []
    }
  },
  methods: {
    getType(value) {
      switch (+value) {
        case 1:
          return 'Cấp phòng ban'
        case 2:
          return 'Cấp công ty'
        default:
          return ''
      }
    },
    getStatus(value) {
      switch (+value) {
        case 1:
          return 'Thành công'
        case 2:
          return 'Thất bại'
        default:
          return ''
      }
    }
  }
}
</script>

<style lang="css" scoped>
.header-table {
  background: #F8F8F8;
  text-align: start;
  word-break: break-word;
}
</style>